import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import { RegistrationActivityCondition } from "../../models/registration-activity-condition";

@Injectable()
export class RegistrationActivityConditionControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getServiceRegistrationActivityConditions(registrationId: string): Observable<RegistrationActivityCondition[]> {
    return this.http.get(this.baseUrl + "registration/" + registrationId + "/registration_activity_condition") as Observable<RegistrationActivityCondition[]>;
  }

  public getRegistrationActivityCondition(registrationActivityConditionId: string): Observable<RegistrationActivityCondition> {
    return this.http.get(this.baseUrl + "registration_activity_condition/" + registrationActivityConditionId) as Observable<RegistrationActivityCondition> ;
  }

  public createActivityCondition(registrationId: string, registrationActivityCondition: RegistrationActivityCondition) {
    const body = JSON.stringify(registrationActivityCondition);
    return this.http.post(this.baseUrl + "registration/" + registrationId + "/registration_activity_condition", body);
  }

  public saveRegistrationActivityCondition(registrationActivityCondition: RegistrationActivityCondition) {
    const body = JSON.stringify(registrationActivityCondition);
    return this.http.put(this.baseUrl + "registration_activity_condition", body, {responseType: "text"});
  }

  public deleteRegistrationActivityCondition(registrationActivityConditionId: string) {
    return this.http.delete(this.baseUrl + "registration_activity_condition/" + registrationActivityConditionId, {responseType: "text"});
  }

  public updateSortOrder(registrationActivityConditions: RegistrationActivityCondition[]) {
    const body = JSON.stringify(registrationActivityConditions);
    return this.http.put(this.baseUrl + "sort_registration_conditions", body, {responseType: "text"});
  }
}
